import { Component } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { ConfirmationService, MessageService } from 'primeng/api';
import { saveAs } from 'file-saver';
import ICredencialUsuario from '../models/credencial';
import { ISemanasHappyMile } from '../models/semanas';
import { CiudadhmService } from './../services/ciudadhm.service';
import { ICiudadHM } from '../models/ciudadhm';
import { SemanaService } from '../services/semana.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { BonoRecomendacionAcumuladoService } from '../services/bonorecomendacionacumulado.service';
import { CiudadesprincipalesService } from '../services/ciudadesprincipales.service';
import { ICiudadPrincipalHM } from '../models/ciudadprincipal';

@Component({
  selector: 'app-bonorecomendacionacumulado',
  templateUrl: './bonorecomendacionacumulado.component.html',
  styleUrls: ['./bonorecomendacionacumulado.component.scss']
})
export class BonorecomendacionacumuladoComponent {
  @ViewChild('dt1') dt!: Table;
  @ViewChild('dt2') dt2!: Table;
  lstCiudad: ICiudadHM[] = [];
  lstCiudad2: ICiudadHM[] = [];
  lstCiudades: ICiudadPrincipalHM[] = [];
  lstChoferes: any[] = [];
  lstBonoRecomendacion: any[] = [];
  lstSemanas: ISemanasHappyMile[] = [];
  mssgListaCiudades: string = '';
  selectedSemana: ISemanasHappyMile = {
    idx: 0,
    id_semana: 0,
    nom_semana: '',
    anio: 0,
    fec_inicio: '',
    fec_fin: '',
    clv_activo: 0
  };


  lstEstatus: any[] = [
    { clv_activo: 0, descripcion: 'TODOS' },
    { clv_activo: 1, descripcion: 'REQUIERE AUTORIZAR' },
    { clv_activo: 2, descripcion: 'BONO ACEPTADO' },
    { clv_activo: 4, descripcion: 'BONO RECHAZADO' }
];

  years: number[] = [];
  loading: boolean = false;
  anio_filtro: any;
  id_ciudad: number = 0;
  id_ciudad_hm: number = 0;
  id_ciudad_hm_vermas: any = null;
  num_anio: number = 0;
  id_ciudad_principal: number = 0;
  dspCliente: boolean = false;
  texto_operacion: string = '';
  clv_operacion: number = 0;
  imp_total_genral: number = 0;
  mostraragregar: boolean = false;
  dsblstCiudades: boolean = true;
  dbsReportes: boolean = false;
  ButtonExportExcel: boolean = false;
  clv_activo: any = null;
  anioReporte1: any;
  loading_reporte1: boolean = false;
  remainingChars: number = 500;
  loading1: boolean = false;
  lstBonoVerMas: any[] = [];
  dspVerMas: boolean = false;
  dspRechazo: boolean = false;


  reactivebonoRecomendacion: FormGroup = new FormGroup({
    idx: new FormControl(null),
    nom_chofer: new FormControl(''),
    cod_chofer: new FormControl(null, [Validators.min(1), Validators.required]),
    id_ciudad_hm: new FormControl(null),
    num_anio: new FormControl(0),
    id_semana: new FormControl(0),
    cod_chofer_recomendado: new FormControl(null, [Validators.min(1), Validators.required]),
    nom_chofer_recomendado: new FormControl(''),
    id_ciudad_recomendado: new FormControl(null),
    selectedSemana: new FormControl(null),
    semana_hm_inicio: new FormControl(null),
    semana_hm_fin: new FormControl(null),
    nombreCiudad: new FormControl(''),
    fec_inicio: new FormControl(''),
    fec_fin: new FormControl(''),
    observacion: new FormControl(''),
    fec_alta: new FormControl(''),
  });

  //Permisos
  user: ICredencialUsuario = {};
  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private semanaService: SemanaService,
    private bonoRecomendacionAcumuladoService: BonoRecomendacionAcumuladoService,
    private CiudadhmService: CiudadhmService,
    private ciudadprincipalService: CiudadesprincipalesService,
    private auth: AuthService
  ) {
    this.cargarInformacionUsuario();
    this.initializeYears();
    this.num_anio = new Date().getFullYear();

    this.reactivebonoRecomendacion.controls['selectedSemana'].valueChanges.subscribe(data => {
      if (data == null) {
        this.reactivebonoRecomendacion.controls['fec_inicio'].setValue('');
        this.reactivebonoRecomendacion.controls['fec_fin'].setValue('');
      } else {
        this.reactivebonoRecomendacion.controls['fec_inicio'].setValue(data.fec_inicio);
        this.reactivebonoRecomendacion.controls['fec_fin'].setValue(data.fec_fin);
      }
    });

  }


  ngOnInit(): void {
    this.cargaInicial();
    this.inicializarFechas();
    this.cargaListaChoferes();
    this.cargarListadoDeSemanasAnio_cast(this.anio_filtro)
    this.cargaCiudadesPrincipales();

  }
  applyFilterGlobal($event: any, stringVal: any) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  applyFilterGlobal2($event: any, stringVal: any) {
    this.dt2.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  cargarInformacionUsuario() {
    this.user = this.auth.user;
  }

  initializeYears(): void {
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= currentYear - 5; year--) {
      this.years.push(year);
    }
  }

  // metodos para el filtro para fechas
  getTargetDescription(ruta: ISemanasHappyMile) {
    if (ruta !== null && ruta !== undefined) {
      let fec_inicio = new Date(ruta.fec_inicio);
      let fec_fin = new Date(ruta.fec_fin);
      return this.formatearFechas(fec_inicio) + ' | ' + this.formatearFechas(fec_fin);
    } else {
      return '';
    }

  }

  cargarListadoDeSemanasAnio_cast(anio_filtro: any) {
    this.lstBonoRecomendacion = []
    let anio_cast: any = 0;
    if (anio_filtro instanceof Date) {
      // will execute
      anio_cast = anio_filtro.getFullYear();
    } else {
      anio_cast = anio_filtro;
    }
    this.num_anio = anio_cast
    this.lstSemanas = [];
    this.loading = true;
    this.semanaService.listarSemanas(anio_cast).subscribe((resp) => {
      this.lstSemanas = resp;
      setTimeout(() => {
        this.loading = false;
      },
        300);
    },
      (error) => {
        this.loading = false;
        this.mostrarDialogoInformativoSinInformacion('<b>Error al cargar Semanas HM</b>.');
      });
  }

  getTargetDescriptioninicio(ruta: ISemanasHappyMile) {
    if (ruta !== null && ruta !== undefined) {
      let fec_inicio = new Date(ruta.fec_inicio);
      let fec_fin = new Date(ruta.fec_fin);
      return this.formatearFechas(fec_inicio);
    } else {
      return '';
    }

  }
  getTargetDescriptionfin(ruta: ISemanasHappyMile) {
    if (ruta !== null && ruta !== undefined) {
      let fec_inicio = new Date(ruta.fec_inicio);
      let fec_fin = new Date(ruta.fec_fin);
      return this.formatearFechas(fec_fin);
    } else {
      return '';
    }

  }

  formatearFechas(fecha: Date): string {
    let fecha_Cast = '';
    var getYear = new Date(fecha).toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date(fecha).toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date(fecha).toLocaleDateString('es-MX', { day: '2-digit' });
    fecha_Cast = getDay + '/' + getMonth + '/' + getYear;
    return fecha_Cast;
  }


  inicializarFechas() {
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    this.anio_filtro = getYear;
  }

  changedSemana(event: any) {
    let id_semana = event.value;
    // Encuentra la semana seleccionada en la lista de semanas
    let semanaSeleccionada = this.lstSemanas.find(semana => semana.id_semana === id_semana);
    if (semanaSeleccionada) {
      // Actualiza los valores en el formulario reactivo
      this.reactivebonoRecomendacion.controls['fec_inicio'].setValue(semanaSeleccionada.fec_inicio);
      this.reactivebonoRecomendacion.controls['fec_fin'].setValue(semanaSeleccionada.fec_fin);
    }
  }

  // -----------filtra y carga la informacion ----
  FiltrarFechaDiariaRuta() {
     this.imp_total_genral = 0;
    this.lstBonoRecomendacion = [];
    this.loading = true;
    if (this.id_ciudad == null || typeof this.id_ciudad === 'undefined' || this.selectedSemana == null || typeof this.selectedSemana === 'undefined') {
      this.mostrarDialogoInformativoSinInformacion('<b>Informativo</b> Debe de seleccionar una semana para poder filtrar');
      this.loading = false;
    } else {
      this.mostraragregar = true;
      this.cargaListaChoferes();
      this.bonoRecomendacionAcumuladoService.getListadoRecomendado(this.num_anio, this.selectedSemana.id_semana, this.id_ciudad).subscribe(
        (resp) => {
          this.lstBonoRecomendacion = resp;
          if (this.lstBonoRecomendacion.length === 0) {
            setTimeout(() => {
              this.loading = false;
            }, 800);
            this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Informativo', detail: 'No existen registros para la fecha seleccionada' });
          } else {
            this.imp_total_genral = 0;

            this.lstBonoRecomendacion.forEach((item) => {
              this.imp_total_genral += item.imp_bono_recomendacion;
            });
            setTimeout(() => {
              this.loading = false;
            }, 800);
          }
        },
        (error) => {
          this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: 'Error en Cargar Movimientos' });
          this.loading = false;
        }
      );
    }
  }

  // -----------filtra y carga la informacion ----
  FiltrarVerMas() {
    this.lstBonoVerMas = [];
    this.loading1 = true;
    if (this.id_ciudad == null || typeof this.id_ciudad_hm_vermas === 'undefined' ||
      this.clv_activo == null || typeof this.clv_activo === 'undefined') {
      this.mostrarDialogoInformativoSinInformacion('<b>Informativo</b> debe de seleccionar la información solicitada para poder filtrar');
      this.loading1 = false;
      return;
    }
    this.bonoRecomendacionAcumuladoService.getListadoRecomendadoVerMas(this.clv_activo, this.id_ciudad_hm_vermas).subscribe((resp) => {
      this.lstBonoVerMas = resp;

      if (this.lstBonoVerMas.length === 0) {
        setTimeout(() => {
          this.loading1 = false;
        }, 800);
        this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Informativo', detail: 'No existen registros para la fecha seleccionada' });
      }
      setTimeout(() => {
        this.loading1 = false;
      }, 800);
    },
      (error) => {
        this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: 'Error en Cargar Movimientos' });
        this.loading1 = false;
      }
    );
  }




  // cargar lista inicial de las ciudades para los dropdown  get
  cargaInicial() {
    this.dsblstCiudades = true;
    this.loading = true;
    this.CiudadhmService.getListadoCiudades().subscribe((resp) => {
      this.lstCiudad = resp.slice(); // Crear una copia independiente
      this.lstCiudad2 = resp.slice(); // Crear una copia independiente
      const index = this.lstCiudad.findIndex(item => item.nombre === 'TODAS LAS CIUDADES');
      if (index !== -1) {
        this.lstCiudad.splice(index, 1);
      }
      this.lstCiudad.push({ id: 0, nombre: 'TODAS LAS CIUDADES', clave_estado: '', id_ciudad_principal: 0, clave_tipoTransporte: 0 });
      setTimeout(() => {
        this.loading = false;
        this.dsblstCiudades = false;
      }, 1000);
    },
      (error) => {
        this.loading = false;
        this.mostrarDialogoInformativoSinInformacion('<b>Error</b> En cargar Listado de Ciudades');
      });
  }

  cargaCiudadesPrincipales() {
    this.dsblstCiudades = true;
    this.loading = true;
    this.ciudadprincipalService.getListadoCiudadesPrincipales().subscribe((resp) => {
      this.lstCiudades = resp.slice();
      const index = this.lstCiudades.findIndex(item => item.nombre === 'TODAS LAS CIUDADES');
      if (index !== -1) {
        this.lstCiudades.splice(index, 1);
      }
      this.lstCiudades.push({ id: 0, nombre: 'TODAS LAS CIUDADES', clave_estado: '' });
      setTimeout(() => {
        this.loading = false;
        this.dsblstCiudades = false;
      }, 1000);
    },
      (error) => {
        this.loading = false;
        this.mostrarDialogoInformativoSinInformacion('<b>Error</b> En cargar Listado de Ciudades');
      });
  }


  cargaListaChoferes() {
    this.lstChoferes = [];
    this.bonoRecomendacionAcumuladoService.getChoferes(this.id_ciudad_hm).subscribe((resp) => {
      this.lstChoferes = resp;
      setTimeout(() => {

      }, 100);
    },
      (error) => {

        this.mostrarDialogoInformativoSinInformacion('<b>Error</b> En cargar Listado de Colaboradores ' + error);
      });
  }





  mostrarDialogoInformativoSinInformacion(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario;
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      key: "sinInformacionDialog"
    });
  }

  changedp(event: any) {
    let eve = event.value;
    this.lstCiudad = [];
    let choferSeleccionado = this.lstChoferes.find(chofer => chofer.cod_chofer === eve);

    if (choferSeleccionado) {
      this.reactivebonoRecomendacion.controls['id_ciudad_hm'].setValue(choferSeleccionado.id_ciudad_hm);
      this.reactivebonoRecomendacion.controls['nombreCiudad'].setValue(choferSeleccionado.desc_ciudad_hm);
      this.reactivebonoRecomendacion.controls['nom_chofer'].setValue(choferSeleccionado.nombre_completo);
    } else {
      this.mssgListaCiudades = 'El colaborador no cuenta con ciudad favor de verificar';
    }
  }


  changedprecomendado(event: any) {
    let eve = event.value;
    this.lstCiudad = [];
    let choferSeleccionado = this.lstChoferes.find(chofer => chofer.cod_chofer === eve);

    if (choferSeleccionado) {
      this.reactivebonoRecomendacion.controls['id_ciudad_recomendado'].setValue(choferSeleccionado.id_ciudad_hm);
      this.reactivebonoRecomendacion.controls['nombreCiudad'].setValue(choferSeleccionado.desc_ciudad_hm);
      this.reactivebonoRecomendacion.controls['nom_chofer_recomendado'].setValue(choferSeleccionado.nombre_completo);

      const fecha = new Date(choferSeleccionado.fec_alta);
      this.reactivebonoRecomendacion.controls['fec_alta'].setValue(fecha);
    } else {
      this.mssgListaCiudades = 'El colaborador no cuenta con ciudad favor de verificar';
    }
  }




  cancelarVentanaModalPdialog() {
    //variables del primero
    this.reactivebonoRecomendacion.controls['observacion'].setValue('');
    this.reactivebonoRecomendacion.controls['cod_chofer_recomendado'].setValue(null);
    this.reactivebonoRecomendacion.controls['cod_chofer'].setValue(null);
    this.reactivebonoRecomendacion.controls['selectedSemana'].setValue(null);
    this.reactivebonoRecomendacion.controls['id_ciudad_hm'].setValue(null);
    this.reactivebonoRecomendacion.controls['id_ciudad_recomendado'].setValue(null);
    this.reactivebonoRecomendacion.controls['fec_alta'].setValue('');

    this.dspCliente = false;
  }

  updateCharCount() {
    const value = this.reactivebonoRecomendacion.get('observacion')?.value || '';
    this.remainingChars = 500 - value.length;
  }


  validarBono(clv_activo: number) {
    let data_enviar = {
      idx: this.reactivebonoRecomendacion.controls['idx'].value || 0,
      cod_chofer: this.reactivebonoRecomendacion.controls['cod_chofer'].value,
      id_ciudad_hm: this.reactivebonoRecomendacion.controls['id_ciudad_hm'].value,
      fec_alta: this.reactivebonoRecomendacion.controls['fec_alta'].value,
      cod_chofer_recomendado: this.reactivebonoRecomendacion.controls['cod_chofer_recomendado'].value,
      observacion: this.reactivebonoRecomendacion.controls['observacion'].value,
      cod_usuario: this.user.cod == undefined ? '0999' : this.user.cod,
      clv_activo: clv_activo,
       id_semana_front: this.selectedSemana.id_semana,
      anio_front : this.selectedSemana.anio,
    };


    this.bonoRecomendacionAcumuladoService.postBonoRecomendacion(data_enviar).subscribe((resp) => {

      if (resp.clv_estatus == 1) {
        this.guardarBono(1, resp.messageDetails);
      }
      else if (resp.clv_estatus == -2) {
        this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: resp.messageDetails });
      }
    });

  }



  guardarBono(clv_activo: number, messageDetails: string) {
    let data_enviar = {
      idx: this.reactivebonoRecomendacion.controls['idx'].value || 0,
      cod_chofer: this.reactivebonoRecomendacion.controls['cod_chofer'].value,
      id_ciudad_hm: this.reactivebonoRecomendacion.controls['id_ciudad_hm'].value,
      fec_alta: this.reactivebonoRecomendacion.controls['fec_alta'].value,
      cod_chofer_recomendado: this.reactivebonoRecomendacion.controls['cod_chofer_recomendado'].value,
      observacion: this.reactivebonoRecomendacion.controls['observacion'].value,
      cod_usuario: this.user.cod == undefined ? '0999' : this.user.cod,
      clv_activo: clv_activo,
      id_semana_front: this.selectedSemana.id_semana,
      anio_front : this.selectedSemana.anio,
    };

    this.confirmationService.confirm({
      // ¿Está seguro que desea guardar el Bono de Recomendación para [Nombre_Recomendado] con beneficio de [Nombre_Quien_Recomienda]
      message: messageDetails,
      header: 'Confirmación de edición de estatus',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.bonoRecomendacionAcumuladoService.postBonoRecomendacion(data_enviar).subscribe((resp) => {

          if (resp.clv_estatus == 1) {
            this.messageService.add({ key: 'msj', severity: 'success', summary: 'Exito', detail: 'Se registro correctamente' });
            this.dspCliente = false;
            this.FiltrarFechaDiariaRuta();
            this.cancelarVentanaModalPdialog();
            this.cancelarDialogRechazo();
          }
          else if (resp.clv_estatus == -2) {
            this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: resp.messageDetails });
          }
        });
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Operación cancelada' });
      }
    });
  }

onCiudadChange(event: any) {
   this.lstBonoRecomendacion = [];}

  cancelarBono(clv_activo: number) {
    let choferSeleccionado = this.lstChoferes.find(chofer => chofer.cod_chofer === this.reactivebonoRecomendacion.controls['cod_chofer'].value);
    let choferRecomendado = this.lstChoferes.find(chofer => chofer.cod_chofer === this.reactivebonoRecomendacion.controls['cod_chofer_recomendado'].value);
    let nombreChofer = choferSeleccionado ? choferSeleccionado.nombre_completo : '';
    let data_enviar = {
      idx: this.reactivebonoRecomendacion.controls['idx'].value || 0,
      cod_chofer: this.reactivebonoRecomendacion.controls['cod_chofer'].value,
      id_ciudad_hm: this.reactivebonoRecomendacion.controls['id_ciudad_hm'].value,
      fec_alta: this.reactivebonoRecomendacion.controls['fec_alta'].value,
      cod_chofer_recomendado: this.reactivebonoRecomendacion.controls['cod_chofer_recomendado'].value,
      observacion: this.reactivebonoRecomendacion.controls['observacion'].value,
      cod_usuario: this.user.cod == undefined ? '0999' : this.user.cod,
      clv_activo: clv_activo,
       id_semana_front: this.selectedSemana.id_semana,
      anio_front : this.selectedSemana.anio,
    };

    this.confirmationService.confirm({
      // ¿Está seguro que desea guardar el Bono de Recomendación para [Nombre_Recomendado] con beneficio de [Nombre_Quien_Recomienda]
      message: '¿Está seguro de <b>Guardar</b> el <b>BONO DE RECOMENDACIÓN</b>  para <b>' + nombreChofer +
        '</b> con beneficio de <b>' + choferRecomendado.nombre_completo + '</b>?',
      header: 'Confirmación de edición de estatus',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.bonoRecomendacionAcumuladoService.postBonoRecomendacion(data_enviar).subscribe((resp) => {

          if (resp.clv_estatus == 1) {
            this.messageService.add({ key: 'msj', severity: 'success', summary: 'Exito', detail: 'Se registro correctamente' });
            this.dspCliente = false;
            this.FiltrarFechaDiariaRuta();
            this.cancelarVentanaModalPdialog();
            this.cancelarDialogRechazo();
          }
          else if (resp.clv_estatus == -2) {
            this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: resp.messageDetails });
          }
        });
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Operación cancelada' });
      }
    });
  }


  AprobarBono(data: any, clv_activo: number) {
    let data_enviar = {
      idx: data.idx,
      cod_chofer: data.cod_chofer,
      id_ciudad_hm: data.id_ciudad_hm,
      fec_alta: data.fec_alta || '1900-01-01',
      cod_chofer_recomendado: data.cod_chofer_recomendado,
      observacion: '',
      cod_usuario: this.user.cod == undefined ? '0999' : this.user.cod,
      clv_activo: clv_activo,
      id_semana_front: this.selectedSemana.id_semana,
      anio_front : this.selectedSemana.anio,

    };

    let msg = '';
    if (clv_activo == 2) { msg = `¿Está seguro de aprobar el <b>BONO POR RECOMENDACIÓN</b> del Colaborador <b>${data.nom_chofer}</b> en la semana
     <b>${this.selectedSemana.id_semana}</b> y año <b>${this.selectedSemana.anio}</b>?`;
    }
    //  if (clv_activo == 2) {
    //   msg = `¿Está seguro de aprobar el <b>BONO POR RECOMENDACIÓN</b> del Colaborador <b>${data.nom_chofer}</b>? en la semana
    //  <b>${data.id_semana}</b> y año <b>${data.num_anio}</b>?`;
    // }
    else if (clv_activo == 3) {
      msg = `¿Está seguro de <b>ELIMINAR</b> el registro del Bono por Recomendación del Colaborador <b>${data.nom_chofer}</b>?`;
    } else if (clv_activo == 4) {
      msg = `¿Está seguro de rechazar el <b>BONO POR RECOMENDACIÓN</b> del Colaborador <b>${data.nom_chofer}</b>?`;
    }
    else if (clv_activo == 5) {
      msg = `¿Está seguro de descancelar el <b>BONO POR RECOMENDACIÓN</b> del Colaborador <b>${data.nom_chofer}</b>?`;
    }
    else if (clv_activo == 6) {
      msg = `¿Está seguro de desaprobar el <b>BONO POR RECOMENDACIÓN</b> del Colaborador <b>${data.nom_chofer}</b>?`;
    }

    this.confirmationService.confirm({
      message: msg,
      header: 'Confirmación de Operación',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.bonoRecomendacionAcumuladoService.postBonoRecomendacion(data_enviar).subscribe((resp) => {
          if (resp.clv_estatus == 1) {
            this.messageService.add({ key: 'msj', severity: 'success', summary: 'Exito', detail: resp.messageDetails });
            this.FiltrarFechaDiariaRuta();
          } else if (resp.clv_estatus == 2) {
            this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'El colaborador ya fue recomendado anteriormente' });
          } else if (resp.clv_estatus == -2) {
            this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: resp.messageDetails });
          }
        });
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Operación cancelada' });
      }
    });

  }


  //botones de agregar
  mostrarModalAgregar() {
    const currentValue = this.reactivebonoRecomendacion.get('observacion')?.value || '';
    this.remainingChars = 500 - currentValue.length;

    this.reactivebonoRecomendacion.markAsPristine();
    this.reactivebonoRecomendacion.markAsUntouched();
    this.reactivebonoRecomendacion.controls['id_ciudad_hm'].disable();
    this.reactivebonoRecomendacion.controls['id_ciudad_recomendado'].disable();
    this.reactivebonoRecomendacion.controls['fec_alta'].disable();
    this.dspCliente = true
    this.texto_operacion = 'Agregar Bono por Recomendación Acumulado';
  }

  // metodo para exportar a excel
  exportarExcel() {
    this.loading1 = true;
    if (this.id_ciudad == null || typeof this.id_ciudad_hm_vermas === 'undefined' ||
      this.clv_activo == null || typeof this.clv_activo === 'undefined') {
      this.mostrarDialogoInformativoSinInformacion('<b>Informativo</b> Debe de seleccionar la información solicitada para poder filtrar');
      this.loading1 = false;
      return;
    }
    this.bonoRecomendacionAcumuladoService.rptBonopermaneciaAcumulado(
      this.clv_activo,
      this.id_ciudad_hm_vermas
    ).subscribe(
      (resp) => {
        if (resp.length === 0 || typeof resp === 'undefined') {
          this.mostrarDialogoInformativoSinInformacion('<b>Aviso</b> No existe informacion del catalogo para exportar (Excel)');
          this.loading_reporte1 = false;
        } else {
          import("xlsx").then((xlsx) => {
            const worksheet = xlsx.utils.json_to_sheet(resp);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer: any = xlsx.write(workbook, {
              bookType: "xlsx",
              type: "array"
            });
            this.saveAsExcelFile(excelBuffer, "ReporteBonoRecomendacionAcumulado" + "_");
          });

          setTimeout(() => {
            this.ButtonExportExcel = false;
            this.loading1 = false;
          }, 1000);
        }
      },
      (error) => {
        this.ButtonExportExcel = false;
        this.loading1 = false;
        this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: 'Error en emitir el reporte de bono por recomendación.' });
      }
    );
  }



  mostrarDialogoInformativo(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario + '.';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
        this.messageService.clear();
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
        this.messageService.clear();
      },
      key: "sinInformacionDialog"
    });
    this.loading = false;
    this.messageService.clear();
  }


  dialogVerMas() {
    this.dspVerMas = true;
  }
  cancelardialogVerMas() {
    this.dspVerMas = false;
    this.id_ciudad_hm_vermas = null;
    this.clv_activo = null;
    this.lstBonoVerMas = []
  }




  dialogRechazo(data: any) {
    this.reactivebonoRecomendacion.controls['idx'].setValue(data.idx);
    this.reactivebonoRecomendacion.controls['cod_chofer_recomendado'].setValue(data.cod_chofer_recomendado);
    this.reactivebonoRecomendacion.controls['cod_chofer'].setValue(data.cod_chofer);
    this.reactivebonoRecomendacion.controls['fec_alta'].setValue(data.fec_alta);
    this.reactivebonoRecomendacion.controls['id_ciudad_hm'].setValue(data.id_ciudad_hm);
    this.dspRechazo = true;

  }

  cancelarDialogRechazo() {
    this.reactivebonoRecomendacion.controls['observacion'].setValue('');
    this.reactivebonoRecomendacion.controls['cod_chofer_recomendado'].setValue(null);
    this.reactivebonoRecomendacion.controls['cod_chofer'].setValue(null);
    this.reactivebonoRecomendacion.controls['selectedSemana'].setValue(null);
    this.reactivebonoRecomendacion.controls['id_ciudad_hm'].setValue(null);
    this.reactivebonoRecomendacion.controls['id_ciudad_recomendado'].setValue(null);
    this.reactivebonoRecomendacion.controls['fec_alta'].setValue('');
    this.reactivebonoRecomendacion.controls['idx'].setValue(null);
    this.dspRechazo = false;
    this.remainingChars = 500;
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    saveAs(data, fileName + "_exportar_" + dateFormat + EXCEL_EXTENSION);
  }

}
